import React from 'react';
import { X, Minus, Square } from 'lucide-react';

const WindowCard = ({ title, children, onClose, className = '' }) => {
    return (
        <div className={`bg-white rounded-xl md:rounded-xl overflow-hidden flex flex-col shadow-mac-window w-full h-full border border-gray-200 ${className}`}>
            {/* Title Bar */}
            <div className="bg-gray-50 px-3 md:px-4 py-2 md:py-3 flex items-center justify-between select-none border-b border-gray-200">
                <div className="flex gap-1.5 md:gap-2 items-center group">
                    <button
                        onClick={onClose}
                        className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-mac-traffic-red hover:brightness-90 flex items-center justify-center transition-all"
                    >
                        <X size={6} className="text-black/50 opacity-0 group-hover:opacity-100 hidden md:block" />
                    </button>
                    <button className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-mac-traffic-yellow hover:brightness-90 flex items-center justify-center transition-all">
                        <Minus size={6} className="text-black/50 opacity-0 group-hover:opacity-100 hidden md:block" />
                    </button>
                    <button className="w-2.5 h-2.5 md:w-3 md:h-3 rounded-full bg-mac-traffic-green hover:brightness-90 flex items-center justify-center transition-all">
                        <Square size={6} className="text-black/50 opacity-0 group-hover:opacity-100 hidden md:block" />
                    </button>
                </div>

                <span className="font-semibold text-xs md:text-sm text-gray-600 truncate absolute left-1/2 -translate-x-1/2 max-w-[60%]">{title}</span>

                <div className="w-10 md:w-14"></div> {/* Spacer for balance */}
            </div>

            {/* Content */}
            <div className="flex-1 relative bg-white overflow-hidden">
                <div className="absolute inset-0 overflow-auto">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default WindowCard;
